import { Text, Card, TextLink } from 'braid-design-system';
import React from 'react';

import Ruler from './components/Ruler/Ruler';

const Estimation = () => (
  <Card>
    <Ruler />
    <Text>
      <TextLink href="/price-guide/">Click to start again</TextLink>
    </Text>
  </Card>
);

export default Estimation;
